"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["name"],
    _excluded2 = ["_f"],
    _excluded3 = ["_f"],
    _excluded4 = ["children"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e23) { throw _e23; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e24) { didErr = true; err = _e24; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function e(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = e(require("react")),
    r = function r(e) {
  return "checkbox" === e.type;
},
    s = function s(e) {
  return e instanceof Date;
},
    a = function a(e) {
  return null == e;
};

var n = function n(e) {
  return "object" == typeof e;
};

var i = function i(e) {
  return !a(e) && !Array.isArray(e) && n(e) && !s(e);
},
    o = function o(e) {
  return i(e) && e.target ? r(e.target) ? e.target.checked : e.target.value : e;
},
    u = function u(e, t) {
  return e.has(function (e) {
    return e.substring(0, e.search(/\.\d+(\.|$)/)) || e;
  }(t));
},
    l = function l(e) {
  return Array.isArray(e) ? e.filter(Boolean) : [];
},
    c = function c(e) {
  return void 0 === e;
},
    d = function d(e, t, r) {
  if (!t || !i(e)) return r;
  var s = l(t.split(/[,[\].]+?/)).reduce(function (e, t) {
    return a(e) ? e : e[t];
  }, e);
  return c(s) || s === e ? c(e[t]) ? r : e[t] : s;
};

var f = "blur",
    m = "focusout",
    y = "change",
    g = "onBlur",
    h = "onChange",
    p = "onSubmit",
    _ = "onTouched",
    v = "all",
    b = "max",
    x = "min",
    A = "maxLength",
    F = "minLength",
    V = "pattern",
    w = "required",
    S = "validate",
    k = t.default.createContext(null),
    D = function D() {
  return t.default.useContext(k);
};

var C = function C(e, t, r) {
  var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
  var a = {};

  var _loop = function _loop(_n) {
    Object.defineProperty(a, _n, {
      get: function get() {
        var a = _n;
        return t[a] !== v && (t[a] = !s || v), r && (r[a] = !0), e[a];
      }
    });
  };

  for (var _n in e) {
    _loop(_n);
  }

  return a;
},
    j = function j(e) {
  return i(e) && !Object.keys(e).length;
},
    E = function E(e, t, r) {
  var s = e.name,
      a = _objectWithoutProperties(e, _excluded);

  return j(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find(function (e) {
    return t[e] === (!r || v);
  });
},
    O = function O(e) {
  return Array.isArray(e) ? e : [e];
},
    B = function B(e, t, r) {
  return r && t ? e === t : !e || !t || e === t || O(e).some(function (e) {
    return e && (e.startsWith(t) || t.startsWith(e));
  });
};

function U(e) {
  var r = t.default.useRef(e);
  r.current = e, t.default.useEffect(function () {
    var t = !e.disabled && r.current.subject.subscribe({
      next: r.current.callback
    });
    return function () {
      return function (e) {
        e && e.unsubscribe();
      }(t);
    };
  }, [e.disabled]);
}

function T(e) {
  var r = D(),
      _ref = e || {},
      _ref$control = _ref.control,
      s = _ref$control === void 0 ? r.control : _ref$control,
      a = _ref.disabled,
      n = _ref.name,
      i = _ref.exact,
      _t$default$useState = t.default.useState(s._formState),
      _t$default$useState2 = _slicedToArray(_t$default$useState, 2),
      o = _t$default$useState2[0],
      u = _t$default$useState2[1],
      l = t.default.useRef({
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }),
      c = t.default.useRef(n),
      d = t.default.useRef(!0);

  c.current = n;
  return U({
    disabled: a,
    callback: t.default.useCallback(function (e) {
      return d.current && B(c.current, e.name, i) && E(e, l.current) && u(_objectSpread(_objectSpread({}, s._formState), e));
    }, [s, i]),
    subject: s._subjects.state
  }), t.default.useEffect(function () {
    return d.current = !0, function () {
      d.current = !1;
    };
  }, []), C(o, s._proxyFormState, l.current, !1);
}

var M = function M(e) {
  return "string" == typeof e;
},
    N = function N(e, t, r, s) {
  var a = Array.isArray(e);
  return M(e) ? (s && t.watch.add(e), d(r, e)) : a ? e.map(function (e) {
    return s && t.watch.add(e), d(r, e);
  }) : (s && (t.watchAll = !0), r);
},
    L = function L(e) {
  return "function" == typeof e;
},
    R = function R(e) {
  for (var _t in e) {
    if (L(e[_t])) return !0;
  }

  return !1;
};

function q(e) {
  var r = D(),
      _ref2 = e || {},
      _ref2$control = _ref2.control,
      s = _ref2$control === void 0 ? r.control : _ref2$control,
      a = _ref2.name,
      n = _ref2.defaultValue,
      o = _ref2.disabled,
      u = _ref2.exact,
      l = t.default.useRef(a);

  l.current = a;
  var d = t.default.useCallback(function (e) {
    if (B(l.current, e.name, u)) {
      var _t2 = N(l.current, s._names, e.values || s._formValues);

      m(c(l.current) || i(_t2) && !R(_t2) ? _objectSpread({}, _t2) : Array.isArray(_t2) ? _toConsumableArray(_t2) : c(_t2) ? n : _t2);
    }
  }, [s, u, n]);
  U({
    disabled: o,
    subject: s._subjects.watch,
    callback: d
  });

  var _t$default$useState3 = t.default.useState(c(n) ? s._getWatch(a) : n),
      _t$default$useState4 = _slicedToArray(_t$default$useState3, 2),
      f = _t$default$useState4[0],
      m = _t$default$useState4[1];

  return t.default.useEffect(function () {
    s._removeUnmounted();
  }), f;
}

function W(e) {
  var r = D(),
      s = e.name,
      _e$control = e.control,
      a = _e$control === void 0 ? r.control : _e$control,
      n = e.shouldUnregister,
      i = u(a._names.array, s),
      l = q({
    control: a,
    name: s,
    defaultValue: d(a._formValues, s, d(a._defaultValues, s, e.defaultValue)),
    exact: !0
  }),
      c = T({
    control: a,
    name: s
  }),
      m = t.default.useRef(a.register(s, _objectSpread(_objectSpread({}, e.rules), {}, {
    value: l
  })));
  return t.default.useEffect(function () {
    var e = function e(_e2, t) {
      var r = d(a._fields, _e2);
      r && (r._f.mount = t);
    };

    return e(s, !0), function () {
      var t = a._options.shouldUnregister || n;
      (i ? t && !a._stateFlags.action : t) ? a.unregister(s) : e(s, !1);
    };
  }, [s, a, i, n]), {
    field: {
      name: s,
      value: l,
      onChange: t.default.useCallback(function (e) {
        m.current.onChange({
          target: {
            value: o(e),
            name: s
          },
          type: y
        });
      }, [s]),
      onBlur: t.default.useCallback(function () {
        m.current.onBlur({
          target: {
            value: d(a._formValues, s),
            name: s
          },
          type: f
        });
      }, [s, a]),
      ref: t.default.useCallback(function (e) {
        var t = d(a._fields, s);
        e && t && e.focus && (t._f.ref = {
          focus: function focus() {
            return e.focus();
          },
          select: function select() {
            return e.select();
          },
          setCustomValidity: function setCustomValidity(t) {
            return e.setCustomValidity(t);
          },
          reportValidity: function reportValidity() {
            return e.reportValidity();
          }
        });
      }, [s, a._fields])
    },
    formState: c,
    fieldState: Object.defineProperties({}, {
      invalid: {
        get: function get() {
          return !!d(c.errors, s);
        }
      },
      isDirty: {
        get: function get() {
          return !!d(c.dirtyFields, s);
        }
      },
      isTouched: {
        get: function get() {
          return !!d(c.touchedFields, s);
        }
      },
      error: {
        get: function get() {
          return d(c.errors, s);
        }
      }
    })
  };
}

var P = function P(e, t, r, s, a) {
  return t ? _objectSpread(_objectSpread({}, r[e]), {}, {
    types: _objectSpread(_objectSpread({}, r[e] && r[e].types ? r[e].types : {}), {}, _defineProperty({}, s, a || !0))
  }) : {};
},
    $ = function $(e) {
  return /^\w*$/.test(e);
},
    I = function I(e) {
  return l(e.replace(/["|']|\]/g, "").split(/\.|\[/));
};

function H(e, t, r) {
  var s = -1;
  var a = $(t) ? [t] : I(t),
      n = a.length,
      o = n - 1;

  for (; ++s < n;) {
    var _t3 = a[s];
    var _n2 = r;

    if (s !== o) {
      var _r = e[_t3];
      _n2 = i(_r) || Array.isArray(_r) ? _r : isNaN(+a[s + 1]) ? {} : [];
    }

    e[_t3] = _n2, e = e[_t3];
  }

  return e;
}

var z = function z(e, t, r) {
  var _iterator = _createForOfIteratorHelper(r || Object.keys(e)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _s = _step.value;

      var _r2 = d(e, _s);

      if (_r2) {
        var _e3 = _r2._f,
            _s2 = _objectWithoutProperties(_r2, _excluded2);

        if (_e3 && t(_e3.name)) {
          if (_e3.ref.focus && c(_e3.ref.focus())) break;

          if (_e3.refs) {
            _e3.refs[0].focus();

            break;
          }
        } else i(_s2) && z(_s2, t);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var G = function G() {
  var e = "undefined" == typeof performance ? Date.now() : 1e3 * performance.now();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
    var r = (16 * Math.random() + e) % 16 | 0;
    return ("x" == t ? r : 3 & r | 8).toString(16);
  });
},
    J = function J(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return r.shouldFocus || c(r.shouldFocus) ? r.focusName || "".concat(e, ".").concat(c(r.focusIndex) ? t : r.focusIndex, ".") : "";
},
    K = function K(e, t, r) {
  return !r && (t.watchAll || t.watch.has(e) || _toConsumableArray(t.watch).some(function (t) {
    return e.startsWith(t) && /^\.\w+/.test(e.slice(t.length));
  }));
};

function Q(e, t) {
  return [].concat(_toConsumableArray(e), _toConsumableArray(O(t)));
}

var X = "undefined" != typeof window && void 0 !== window.HTMLElement && "undefined" != typeof document;

function Y(e) {
  var t;
  var r = Array.isArray(e);
  if (e instanceof Date) t = new Date(e);else if (e instanceof Set) t = new Set(e);else {
    if (X && (e instanceof Blob || e instanceof FileList) || !r && !i(e)) return e;
    t = r ? [] : {};

    for (var _r3 in e) {
      if (L(e[_r3])) {
        t = e;
        break;
      }

      t[_r3] = Y(e[_r3]);
    }
  }
  return t;
}

var Z = function Z(e) {
  return Array.isArray(e) ? e.map(function () {}) : void 0;
};

function ee(e, t, r) {
  return [].concat(_toConsumableArray(e.slice(0, t)), _toConsumableArray(O(r)), _toConsumableArray(e.slice(t)));
}

var te = function te(e, t, r) {
  return Array.isArray(e) ? (c(e[r]) && (e[r] = void 0), e.splice(r, 0, e.splice(t, 1)[0]), e) : [];
};

function re(e, t) {
  return [].concat(_toConsumableArray(O(t)), _toConsumableArray(O(e)));
}

var se = function se(e, t) {
  return c(t) ? [] : function (e, t) {
    var r = 0;

    var s = _toConsumableArray(e);

    var _iterator2 = _createForOfIteratorHelper(t),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _e4 = _step2.value;
        s.splice(_e4 - r, 1), r++;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return l(s).length ? s : [];
  }(e, O(t).sort(function (e, t) {
    return e - t;
  }));
},
    ae = function ae(e, t, r) {
  e[t] = [e[r], e[r] = e[t]][0];
};

function ne(e, t) {
  var r = $(t) ? [t] : I(t),
      s = 1 == r.length ? e : function (e, t) {
    var r = t.slice(0, -1).length;
    var s = 0;

    for (; s < r;) {
      e = c(e) ? s++ : e[t[s++]];
    }

    return e;
  }(e, r),
      a = r[r.length - 1];
  var n;
  s && delete s[a];

  for (var _t4 = 0; _t4 < r.slice(0, -1).length; _t4++) {
    var _s3 = void 0,
        _a = -1;

    var _o = r.slice(0, -(_t4 + 1)),
        _u = _o.length - 1;

    for (_t4 > 0 && (n = e); ++_a < _o.length;) {
      var _t5 = _o[_a];
      _s3 = _s3 ? _s3[_t5] : e[_t5], _u === _a && (i(_s3) && j(_s3) || Array.isArray(_s3) && !_s3.filter(function (e) {
        return !c(e);
      }).length) && (n ? delete n[_t5] : delete e[_t5]), n = _s3;
    }
  }

  return e;
}

var ie = function ie(e, t, r) {
  return e[t] = r, e;
};

function oe() {
  var e = [];
  return {
    get observers() {
      return e;
    },

    next: function next(t) {
      var _iterator3 = _createForOfIteratorHelper(e),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _r4 = _step3.value;

          _r4.next(t);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    },
    subscribe: function subscribe(t) {
      return e.push(t), {
        unsubscribe: function unsubscribe() {
          e = e.filter(function (e) {
            return e !== t;
          });
        }
      };
    },
    unsubscribe: function unsubscribe() {
      e = [];
    }
  };
}

var ue = function ue(e) {
  return a(e) || !n(e);
};

function le(e, t) {
  if (ue(e) || ue(t)) return e === t;
  if (s(e) && s(t)) return e.getTime() === t.getTime();
  var r = Object.keys(e),
      a = Object.keys(t);
  if (r.length !== a.length) return !1;

  for (var _i = 0, _r5 = r; _i < _r5.length; _i++) {
    var _n3 = _r5[_i];
    var _r6 = e[_n3];
    if (!a.includes(_n3)) return !1;

    if ("ref" !== _n3) {
      var _e5 = t[_n3];
      if (s(_r6) && s(_e5) || i(_r6) && i(_e5) || Array.isArray(_r6) && Array.isArray(_e5) ? !le(_r6, _e5) : _r6 !== _e5) return !1;
    }
  }

  return !0;
}

var ce = function ce(e) {
  return {
    isOnSubmit: !e || e === p,
    isOnBlur: e === g,
    isOnChange: e === h,
    isOnAll: e === v,
    isOnTouch: e === _
  };
},
    de = function de(e) {
  return "boolean" == typeof e;
},
    fe = function fe(e) {
  return "file" === e.type;
},
    me = function me(e) {
  var t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
},
    ye = function ye(e) {
  return "select-multiple" === e.type;
},
    ge = function ge(e) {
  return "radio" === e.type;
},
    he = function he(e) {
  return me(e) && e.isConnected;
};

function pe(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = Array.isArray(e);
  if (i(e) || r) for (var _r7 in e) {
    Array.isArray(e[_r7]) || i(e[_r7]) && !R(e[_r7]) ? (t[_r7] = Array.isArray(e[_r7]) ? [] : {}, pe(e[_r7], t[_r7])) : a(e[_r7]) || (t[_r7] = !0);
  }
  return t;
}

var _e = function _e(e, t) {
  return function e(t, r, s) {
    var n = Array.isArray(t);
    if (i(t) || n) for (var _n4 in t) {
      Array.isArray(t[_n4]) || i(t[_n4]) && !R(t[_n4]) ? c(r) || ue(s[_n4]) ? s[_n4] = Array.isArray(t[_n4]) ? pe(t[_n4], []) : _objectSpread({}, pe(t[_n4])) : e(t[_n4], a(r) ? {} : r[_n4], s[_n4]) : s[_n4] = !le(t[_n4], r[_n4]);
    }
    return s;
  }(e, t, pe(t));
};

var ve = {
  value: !1,
  isValid: !1
},
    be = {
  value: !0,
  isValid: !0
};

var xe = function xe(e) {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      var _t6 = e.filter(function (e) {
        return e && e.checked && !e.disabled;
      }).map(function (e) {
        return e.value;
      });

      return {
        value: _t6,
        isValid: !!_t6.length
      };
    }

    return e[0].checked && !e[0].disabled ? e[0].attributes && !c(e[0].attributes.value) ? c(e[0].value) || "" === e[0].value ? be : {
      value: e[0].value,
      isValid: !0
    } : be : ve;
  }

  return ve;
},
    Ae = function Ae(e, _ref3) {
  var t = _ref3.valueAsNumber,
      r = _ref3.valueAsDate,
      s = _ref3.setValueAs;
  return c(e) ? e : t ? "" === e || a(e) ? NaN : +e : r && M(e) ? new Date(e) : s ? s(e) : e;
};

var Fe = {
  isValid: !1,
  value: null
};

var Ve = function Ve(e) {
  return Array.isArray(e) ? e.reduce(function (e, t) {
    return t && t.checked && !t.disabled ? {
      isValid: !0,
      value: t.value
    } : e;
  }, Fe) : Fe;
};

function we(e) {
  var t = e.ref;
  if (!(e.refs ? e.refs.every(function (e) {
    return e.disabled;
  }) : t.disabled)) return fe(t) ? t.files : ge(t) ? Ve(e.refs).value : ye(t) ? _toConsumableArray(t.selectedOptions).map(function (_ref4) {
    var e = _ref4.value;
    return e;
  }) : r(t) ? xe(e.refs).value : Ae(c(t.value) ? e.ref.value : t.value, e);
}

var Se = function Se(e) {
  return e instanceof RegExp;
},
    ke = function ke(e) {
  return c(e) ? void 0 : Se(e) ? e.source : i(e) ? Se(e.value) ? e.value.source : e.value : e;
};

function De(e, t, r) {
  var s = d(e, r);
  if (s || $(r)) return {
    error: s,
    name: r
  };
  var a = r.split(".");

  for (; a.length;) {
    var _s4 = a.join("."),
        _n5 = d(t, _s4),
        _i2 = d(e, _s4);

    if (_n5 && !Array.isArray(_n5) && r !== _s4) return {
      name: r
    };
    if (_i2 && _i2.type) return {
      name: _s4,
      error: _i2
    };
    a.pop();
  }

  return {
    name: r
  };
}

var Ce = function Ce(e) {
  return M(e) || t.default.isValidElement(e);
};

function je(e, t) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "validate";
  if (Ce(e) || Array.isArray(e) && e.every(Ce) || de(e) && !e) return {
    type: r,
    message: Ce(e) ? e : "",
    ref: t
  };
}

var Ee = function Ee(e) {
  return i(e) && !Se(e) ? e : {
    value: e,
    message: ""
  };
},
    Oe = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t, s, n) {
    var _e$_f, o, u, l, c, d, f, m, y, g, h, p, _, v, k, D, C, E, O, B, U, T, N, _ref6, _e6, _t7, _e7, _r8, _n6, _i3, _s5, _s6, _e8, _r9, _n7, _i4, _Ee, _e9, _r10, _e10, _e11, _r11, _a2;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _e$_f = e._f, o = _e$_f.ref, u = _e$_f.refs, l = _e$_f.required, c = _e$_f.maxLength, d = _e$_f.minLength, f = _e$_f.min, m = _e$_f.max, y = _e$_f.pattern, g = _e$_f.validate, h = _e$_f.name, p = _e$_f.valueAsNumber, _ = _e$_f.mount, v = _e$_f.disabled;

            if (!(!_ || v)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {});

          case 3:
            k = u ? u[0] : o, D = function D(e) {
              n && k.reportValidity && (k.setCustomValidity(de(e) ? "" : e || " "), k.reportValidity());
            }, C = {}, E = ge(o), O = r(o), B = E || O, U = (p || fe(o)) && !o.value || "" === t || Array.isArray(t) && !t.length, T = P.bind(null, h, s, C), N = function N(e, t, r) {
              var s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : A;
              var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : F;
              var n = e ? t : r;
              C[h] = _objectSpread({
                type: e ? s : a,
                message: n,
                ref: o
              }, T(e ? s : a, n));
            };

            if (!(l && (!B && (U || a(t)) || de(t) && !t || O && !xe(u).isValid || E && !Ve(u).isValid))) {
              _context.next = 8;
              break;
            }

            _ref6 = Ce(l) ? {
              value: !!l,
              message: l
            } : Ee(l), _e6 = _ref6.value, _t7 = _ref6.message;

            if (!(_e6 && (C[h] = _objectSpread({
              type: w,
              message: _t7,
              ref: k
            }, T(w, _t7)), !s))) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", (D(_t7), C));

          case 8:
            if (U || a(f) && a(m)) {
              _context.next = 13;
              break;
            }

            _n6 = Ee(m), _i3 = Ee(f);

            if (a(t) || isNaN(t)) {
              _s5 = o.valueAsDate || new Date(t);
              M(_n6.value) && (_e7 = _s5 > new Date(_n6.value)), M(_i3.value) && (_r8 = _s5 < new Date(_i3.value));
            } else {
              _s6 = o.valueAsNumber || +t;
              a(_n6.value) || (_e7 = _s6 > _n6.value), a(_i3.value) || (_r8 = _s6 < _i3.value);
            }

            if (!((_e7 || _r8) && (N(!!_e7, _n6.message, _i3.message, b, x), !s))) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", (D(C[h].message), C));

          case 13:
            if (!((c || d) && !U && M(t))) {
              _context.next = 17;
              break;
            }

            _e8 = Ee(c), _r9 = Ee(d), _n7 = !a(_e8.value) && t.length > _e8.value, _i4 = !a(_r9.value) && t.length < _r9.value;

            if (!((_n7 || _i4) && (N(_n7, _e8.message, _r9.message), !s))) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", (D(C[h].message), C));

          case 17:
            if (!(y && !U && M(t))) {
              _context.next = 21;
              break;
            }

            _Ee = Ee(y), _e9 = _Ee.value, _r10 = _Ee.message;

            if (!(Se(_e9) && !t.match(_e9) && (C[h] = _objectSpread({
              type: V,
              message: _r10,
              ref: o
            }, T(V, _r10)), !s))) {
              _context.next = 21;
              break;
            }

            return _context.abrupt("return", (D(_r10), C));

          case 21:
            if (!g) {
              _context.next = 52;
              break;
            }

            if (!L(g)) {
              _context.next = 33;
              break;
            }

            _context.t0 = je;
            _context.next = 26;
            return g(t);

          case 26:
            _context.t1 = _context.sent;
            _context.t2 = k;
            _e10 = (0, _context.t0)(_context.t1, _context.t2);

            if (!(_e10 && (C[h] = _objectSpread(_objectSpread({}, _e10), T(S, _e10.message)), !s))) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("return", (D(_e10.message), C));

          case 31:
            _context.next = 52;
            break;

          case 33:
            if (!i(g)) {
              _context.next = 52;
              break;
            }

            _e11 = {};
            _context.t3 = _regeneratorRuntime.keys(g);

          case 36:
            if ((_context.t4 = _context.t3()).done) {
              _context.next = 50;
              break;
            }

            _r11 = _context.t4.value;

            if (!(!j(_e11) && !s)) {
              _context.next = 40;
              break;
            }

            return _context.abrupt("break", 50);

          case 40:
            _context.t5 = je;
            _context.next = 43;
            return g[_r11](t);

          case 43:
            _context.t6 = _context.sent;
            _context.t7 = k;
            _context.t8 = _r11;
            _a2 = (0, _context.t5)(_context.t6, _context.t7, _context.t8);
            _a2 && (_e11 = _objectSpread(_objectSpread({}, _a2), T(_r11, _a2.message)), D(_a2.message), s && (C[h] = _e11));
            _context.next = 36;
            break;

          case 50:
            if (!(!j(_e11) && (C[h] = _objectSpread({
              ref: k
            }, _e11), !s))) {
              _context.next = 52;
              break;
            }

            return _context.abrupt("return", C);

          case 52:
            return _context.abrupt("return", (D(!0), C));

          case 53:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function Oe(_x, _x2, _x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();

var Be = {
  mode: p,
  reValidateMode: h,
  shouldFocusError: !0
};

function Ue() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var t,
      n = _objectSpread(_objectSpread({}, Be), e),
      i = {
    isDirty: !1,
    isValidating: !1,
    dirtyFields: {},
    isSubmitted: !1,
    submitCount: 0,
    touchedFields: {},
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    errors: {}
  },
      y = {},
      g = Y(n.defaultValues) || {},
      h = n.shouldUnregister ? {} : Y(g),
      p = {
    action: !1,
    mount: !1,
    watch: !1
  },
      _ = {
    mount: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set()
  },
      b = 0,
      x = {};

  var A = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  },
      F = {
    watch: oe(),
    array: oe(),
    state: oe()
  },
      V = ce(n.mode),
      w = ce(n.reValidateMode),
      S = n.criteriaMode === v,
      k = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              t = !1;
              _context2.t0 = A.isValid;

              if (!_context2.t0) {
                _context2.next = 16;
                break;
              }

              if (!n.resolver) {
                _context2.next = 11;
                break;
              }

              _context2.t2 = j;
              _context2.next = 7;
              return B();

            case 7:
              _context2.t3 = _context2.sent.errors;
              _context2.t1 = (0, _context2.t2)(_context2.t3);
              _context2.next = 14;
              break;

            case 11:
              _context2.next = 13;
              return U(y, !0);

            case 13:
              _context2.t1 = _context2.sent;

            case 14:
              t = _context2.t1;
              e || t === i.isValid || (i.isValid = t, F.state.next({
                isValid: t
              }));

            case 16:
              return _context2.abrupt("return", t);

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function k(_x5) {
      return _ref7.apply(this, arguments);
    };
  }(),
      D = function D(e, t, r, s) {
    var a = d(y, e);

    if (a) {
      var _n8 = d(h, e, c(r) ? d(g, e) : r);

      c(_n8) || s && s.defaultChecked || t ? H(h, e, t ? _n8 : we(a._f)) : q(e, _n8), p.mount && k();
    }
  },
      C = function C(e, t, r, s, a) {
    var n = !1;
    var o = {
      name: e
    },
        u = d(i.touchedFields, e);

    if (A.isDirty) {
      var _e12 = i.isDirty;
      i.isDirty = o.isDirty = T(), n = _e12 !== o.isDirty;
    }

    if (A.dirtyFields && (!r || s)) {
      var _r12 = d(i.dirtyFields, e);

      le(d(g, e), t) ? ne(i.dirtyFields, e) : H(i.dirtyFields, e, !0), o.dirtyFields = i.dirtyFields, n = n || _r12 !== d(i.dirtyFields, e);
    }

    return r && !u && (H(i.touchedFields, e, r), o.touchedFields = i.touchedFields, n = n || A.touchedFields && u !== r), n && a && F.state.next(o), n ? o : {};
  },
      E = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(r, s, a, n) {
      var o, u, l, _e13;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              o = d(i.errors, r), u = A.isValid && i.isValid !== s;

              if (e.delayError && a ? (l = function l() {
                return function (e, t) {
                  H(i.errors, e, t), F.state.next({
                    errors: i.errors
                  });
                }(r, a);
              }, t = function t(e) {
                clearTimeout(b), b = window.setTimeout(l, e);
              }, t(e.delayError)) : (clearTimeout(b), t = null, a ? H(i.errors, r, a) : ne(i.errors, r)), (a ? !le(o, a) : o) || !j(n) || u) {
                _e13 = _objectSpread(_objectSpread(_objectSpread({}, n), u ? {
                  isValid: s
                } : {}), {}, {
                  errors: i.errors,
                  name: r
                });
                i = _objectSpread(_objectSpread({}, i), _e13), F.state.next(_e13);
              }

              x[r]--, A.isValidating && !Object.values(x).some(function (e) {
                return e;
              }) && (F.state.next({
                isValidating: !1
              }), x = {});

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function E(_x6, _x7, _x8, _x9) {
      return _ref8.apply(this, arguments);
    };
  }(),
      B = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!n.resolver) {
                _context4.next = 6;
                break;
              }

              _context4.next = 3;
              return n.resolver(_objectSpread({}, h), n.context, function (e, t, r, s) {
                var a = {};

                var _iterator4 = _createForOfIteratorHelper(e),
                    _step4;

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var _r13 = _step4.value;

                    var _e14 = d(t, _r13);

                    _e14 && H(a, _r13, _e14._f);
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                return {
                  criteriaMode: r,
                  names: _toConsumableArray(e),
                  fields: a,
                  shouldUseNativeValidation: s
                };
              }(e || _.mount, y, n.criteriaMode, n.shouldUseNativeValidation));

            case 3:
              _context4.t0 = _context4.sent;
              _context4.next = 7;
              break;

            case 6:
              _context4.t0 = {};

            case 7:
              return _context4.abrupt("return", _context4.t0);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function B(_x10) {
      return _ref9.apply(this, arguments);
    };
  }(),
      U = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t) {
      var r,
          _s7,
          _a3,
          _e15,
          _s8,
          _s9,
          _args5 = arguments;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              r = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {
                valid: !0
              };
              _context5.t0 = _regeneratorRuntime.keys(e);

            case 2:
              if ((_context5.t1 = _context5.t0()).done) {
                _context5.next = 20;
                break;
              }

              _s7 = _context5.t1.value;
              _a3 = e[_s7];

              if (!_a3) {
                _context5.next = 18;
                break;
              }

              _e15 = _a3._f, _s8 = _objectWithoutProperties(_a3, _excluded3);

              if (!_e15) {
                _context5.next = 14;
                break;
              }

              _context5.next = 10;
              return Oe(_a3, d(h, _e15.name), S, n.shouldUseNativeValidation);

            case 10:
              _s9 = _context5.sent;

              if (!(_s9[_e15.name] && (r.valid = !1, t))) {
                _context5.next = 13;
                break;
              }

              return _context5.abrupt("break", 20);

            case 13:
              t || (_s9[_e15.name] ? H(i.errors, _e15.name, _s9[_e15.name]) : ne(i.errors, _e15.name));

            case 14:
              _context5.t2 = _s8;

              if (!_context5.t2) {
                _context5.next = 18;
                break;
              }

              _context5.next = 18;
              return U(_s8, t, r);

            case 18:
              _context5.next = 2;
              break;

            case 20:
              return _context5.abrupt("return", r.valid);

            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function U(_x11, _x12) {
      return _ref10.apply(this, arguments);
    };
  }(),
      T = function T(e, t) {
    return e && t && H(h, e, t), !le(G(), g);
  },
      R = function R(e, t, r) {
    var s = _objectSpread({}, p.mount ? h : c(t) ? g : M(e) ? _defineProperty({}, e, t) : t);

    return N(e, _, s, r);
  },
      q = function q(e, t) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var n = d(y, e);
    var i = t;

    if (n) {
      var _s10 = n._f;
      _s10 && (!_s10.disabled && H(h, e, Ae(t, _s10)), i = X && me(_s10.ref) && a(t) ? "" : t, ye(_s10.ref) ? _toConsumableArray(_s10.ref.options).forEach(function (e) {
        return e.selected = i.includes(e.value);
      }) : _s10.refs ? r(_s10.ref) ? _s10.refs.length > 1 ? _s10.refs.forEach(function (e) {
        return !e.disabled && (e.checked = Array.isArray(i) ? !!i.find(function (t) {
          return t === e.value;
        }) : i === e.value);
      }) : _s10.refs[0] && (_s10.refs[0].checked = !!i) : _s10.refs.forEach(function (e) {
        return e.checked = e.value === i;
      }) : fe(_s10.ref) ? _s10.ref.value = "" : (_s10.ref.value = i, _s10.ref.type || F.watch.next({
        name: e
      })));
    }

    (s.shouldDirty || s.shouldTouch) && C(e, i, s.shouldTouch, s.shouldDirty, !0), s.shouldValidate && I(e);
  },
      W = function W(e, t, r) {
    for (var _a4 in t) {
      var _n9 = t[_a4],
          _i5 = "".concat(e, ".").concat(_a4),
          _o2 = d(y, _i5);

      !_.array.has(e) && ue(_n9) && (!_o2 || _o2._f) || s(_n9) ? q(_i5, _n9, r) : W(_i5, _n9, r);
    }
  },
      P = function P(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var s = d(y, e),
        n = _.array.has(e),
        o = Y(t);

    H(h, e, o), n ? (F.array.next({
      name: e,
      values: h
    }), (A.isDirty || A.dirtyFields) && r.shouldDirty && (i.dirtyFields = _e(g, h), F.state.next({
      name: e,
      dirtyFields: i.dirtyFields,
      isDirty: T(e, o)
    }))) : !s || s._f || a(o) ? q(e, o, r) : W(e, o, r), K(e, _) && F.state.next({}), F.watch.next({
      name: e
    });
  },
      $ = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
      var r, s, a, l, _c, _g, _p, _v, _b, _A, _D, _yield$B, _e16, _t8, _r14, u;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              r = e.target;
              s = r.name;
              a = d(y, s);

              if (!a) {
                _context6.next = 27;
                break;
              }

              _g = r.type ? we(a._f) : o(e), _p = e.type === f || e.type === m, _v = !((u = a._f).mount && (u.required || u.min || u.max || u.maxLength || u.minLength || u.pattern || u.validate) || n.resolver || d(i.errors, s) || a._f.deps) || function (e, t, r, s, a) {
                return !a.isOnAll && (!r && a.isOnTouch ? !(t || e) : (r ? s.isOnBlur : a.isOnBlur) ? !e : !(r ? s.isOnChange : a.isOnChange) || e);
              }(_p, d(i.touchedFields, s), i.isSubmitted, w, V), _b = K(s, _, _p);
              H(h, s, _g), _p ? (a._f.onBlur && a._f.onBlur(e), t && t(0)) : a._f.onChange && a._f.onChange(e);
              _A = C(s, _g, _p, !1), _D = !j(_A) || _b;

              if (!(!_p && F.watch.next({
                name: s,
                type: e.type
              }), _v)) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return", _D && F.state.next(_objectSpread({
                name: s
              }, _b ? {} : _A)));

            case 9:
              if (!(!_p && _b && F.state.next({}), x[s] = (x[s], 1), F.state.next({
                isValidating: !0
              }), n.resolver)) {
                _context6.next = 19;
                break;
              }

              _context6.next = 12;
              return B([s]);

            case 12:
              _yield$B = _context6.sent;
              _e16 = _yield$B.errors;
              _t8 = De(i.errors, y, s);
              _r14 = De(_e16, y, _t8.name || s);
              l = _r14.error, s = _r14.name, _c = j(_e16);
              _context6.next = 26;
              break;

            case 19:
              _context6.next = 21;
              return Oe(a, d(h, s), S, n.shouldUseNativeValidation);

            case 21:
              _context6.t0 = s;
              l = _context6.sent[_context6.t0];
              _context6.next = 25;
              return k(!0);

            case 25:
              _c = _context6.sent;

            case 26:
              a._f.deps && I(a._f.deps), E(s, _c, l, _A);

            case 27:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function $(_x13) {
      return _ref12.apply(this, arguments);
    };
  }(),
      I = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
      var t,
          r,
          s,
          a,
          _t9,
          _args9 = arguments;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              t = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
              a = O(e);

              if (!(F.state.next({
                isValidating: !0
              }), n.resolver)) {
                _context9.next = 9;
                break;
              }

              _context9.next = 5;
              return function () {
                var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
                  var _yield$B2, t, _iterator5, _step5, _r15, _e17;

                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return B();

                        case 2:
                          _yield$B2 = _context7.sent;
                          t = _yield$B2.errors;

                          if (e) {
                            _iterator5 = _createForOfIteratorHelper(e);

                            try {
                              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                                _r15 = _step5.value;
                                _e17 = d(t, _r15);
                                _e17 ? H(i.errors, _r15, _e17) : ne(i.errors, _r15);
                              }
                            } catch (err) {
                              _iterator5.e(err);
                            } finally {
                              _iterator5.f();
                            }
                          } else i.errors = t;

                          return _context7.abrupt("return", t);

                        case 6:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }));

                return function (_x15) {
                  return _ref14.apply(this, arguments);
                };
              }()(c(e) ? e : a);

            case 5:
              _t9 = _context9.sent;
              r = j(_t9), s = e ? !a.some(function (e) {
                return d(_t9, e);
              }) : r;
              _context9.next = 19;
              break;

            case 9:
              if (!e) {
                _context9.next = 16;
                break;
              }

              _context9.next = 12;
              return Promise.all(a.map( /*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
                  var t;
                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          t = d(y, e);
                          _context8.next = 3;
                          return U(t && t._f ? _defineProperty({}, e, t) : t);

                        case 3:
                          return _context8.abrupt("return", _context8.sent);

                        case 4:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }));

                return function (_x16) {
                  return _ref15.apply(this, arguments);
                };
              }()));

            case 12:
              s = _context9.sent.every(Boolean);
              (s || i.isValid) && k();
              _context9.next = 19;
              break;

            case 16:
              _context9.next = 18;
              return U(y);

            case 18:
              s = r = _context9.sent;

            case 19:
              return _context9.abrupt("return", (F.state.next(_objectSpread(_objectSpread(_objectSpread({}, !M(e) || A.isValid && r !== i.isValid ? {} : {
                name: e
              }), n.resolver ? {
                isValid: r
              } : {}), {}, {
                errors: i.errors,
                isValidating: !1
              })), t.shouldFocus && !s && z(y, function (e) {
                return d(i.errors, e);
              }, e ? a : _.mount), s));

            case 20:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function I(_x14) {
      return _ref13.apply(this, arguments);
    };
  }(),
      G = function G(e) {
    var t = _objectSpread(_objectSpread({}, g), p.mount ? h : {});

    return c(e) ? t : M(e) ? d(t, e) : e.map(function (e) {
      return d(t, e);
    });
  },
      J = function J(e, t) {
    return {
      invalid: !!d((t || i).errors, e),
      isDirty: !!d((t || i).dirtyFields, e),
      isTouched: !!d((t || i).touchedFields, e),
      error: d((t || i).errors, e)
    };
  },
      Q = function Q(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _iterator6 = _createForOfIteratorHelper(e ? O(e) : _.mount),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var r = _step6.value;
        _.mount.delete(r), _.array.delete(r), d(y, r) && (t.keepValue || (ne(y, r), ne(h, r)), !t.keepError && ne(i.errors, r), !t.keepDirty && ne(i.dirtyFields, r), !t.keepTouched && ne(i.touchedFields, r), !n.shouldUnregister && !t.keepDefaultValue && ne(g, r));
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }

    F.watch.next({}), F.state.next(_objectSpread(_objectSpread({}, i), t.keepDirty ? {
      isDirty: T()
    } : {})), !t.keepIsValid && k();
  },
      Z = function Z(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var s = d(y, e);
    var a = de(t.disabled);
    return H(y, e, {
      _f: _objectSpread(_objectSpread({}, s && s._f ? s._f : {
        ref: {
          name: e
        }
      }), {}, {
        name: e,
        mount: !0
      }, t)
    }), _.mount.add(e), s ? a && H(h, e, t.disabled ? void 0 : d(h, e, we(s._f))) : D(e, !0, t.value), _objectSpread(_objectSpread(_objectSpread({}, a ? {
      disabled: t.disabled
    } : {}), n.shouldUseNativeValidation ? {
      required: !!t.required,
      min: ke(t.min),
      max: ke(t.max),
      minLength: ke(t.minLength),
      maxLength: ke(t.maxLength),
      pattern: ke(t.pattern)
    } : {}), {}, {
      name: e,
      onChange: $,
      onBlur: $,
      ref: function ref(a) {
        if (a) {
          Z(e, t), s = d(y, e);

          var _n10 = c(a.value) && a.querySelectorAll && a.querySelectorAll("input,select,textarea")[0] || a,
              _i6 = function (e) {
            return ge(e) || r(e);
          }(_n10),
              _o3 = s._f.refs || [];

          if (_i6 ? _o3.find(function (e) {
            return e === _n10;
          }) : _n10 === s._f.ref) return;
          H(y, e, {
            _f: _objectSpread(_objectSpread({}, s._f), _i6 ? {
              refs: [].concat(_toConsumableArray(_o3.filter(he)), [_n10], _toConsumableArray(Array.isArray(d(g, e)) ? [{}] : [])),
              ref: {
                type: _n10.type,
                name: e
              }
            } : {
              ref: _n10
            })
          }), D(e, !1, void 0, _n10);
        } else s = d(y, e, {}), s._f && (s._f.mount = !1), (n.shouldUnregister || t.shouldUnregister) && (!u(_.array, e) || !p.action) && _.unMount.add(e);
      }
    });
  };

  return {
    control: {
      register: Z,
      unregister: Q,
      getFieldState: J,
      _executeSchema: B,
      _getWatch: R,
      _getDirty: T,
      _updateValid: k,
      _removeUnmounted: function _removeUnmounted() {
        var _iterator7 = _createForOfIteratorHelper(_.unMount),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _e18 = _step7.value;

            var _t10 = d(y, _e18);

            _t10 && (_t10._f.refs ? _t10._f.refs.every(function (e) {
              return !he(e);
            }) : !he(_t10._f.ref)) && Q(_e18);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        _.unMount = new Set();
      },
      _updateFieldArray: function _updateFieldArray(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var r = arguments.length > 2 ? arguments[2] : undefined;
        var s = arguments.length > 3 ? arguments[3] : undefined;
        var a = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
        var n = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;

        if (s && r) {
          if (p.action = !0, n && Array.isArray(d(y, e))) {
            var _t11 = r(d(y, e), s.argA, s.argB);

            a && H(y, e, _t11);
          }

          if (A.errors && n && Array.isArray(d(i.errors, e))) {
            var _t12 = r(d(i.errors, e), s.argA, s.argB);

            a && H(i.errors, e, _t12), function (e, t) {
              !l(d(e, t)).length && ne(e, t);
            }(i.errors, e);
          }

          if (A.touchedFields && n && Array.isArray(d(i.touchedFields, e))) {
            var _t13 = r(d(i.touchedFields, e), s.argA, s.argB);

            a && H(i.touchedFields, e, _t13);
          }

          A.dirtyFields && (i.dirtyFields = _e(g, h)), F.state.next({
            isDirty: T(e, t),
            dirtyFields: i.dirtyFields,
            errors: i.errors,
            isValid: i.isValid
          });
        } else H(h, e, t);
      },
      _getFieldArray: function _getFieldArray(t) {
        return l(d(p.mount ? h : g, t, e.shouldUnregister ? d(g, t, []) : []));
      },
      _subjects: F,
      _proxyFormState: A,

      get _fields() {
        return y;
      },

      get _formValues() {
        return h;
      },

      get _stateFlags() {
        return p;
      },

      set _stateFlags(e) {
        p = e;
      },

      get _defaultValues() {
        return g;
      },

      get _names() {
        return _;
      },

      set _names(e) {
        _ = e;
      },

      get _formState() {
        return i;
      },

      set _formState(e) {
        i = e;
      },

      get _options() {
        return n;
      },

      set _options(e) {
        n = _objectSpread(_objectSpread({}, n), e);
      }

    },
    trigger: I,
    register: Z,
    handleSubmit: function handleSubmit(e, t) {
      return /*#__PURE__*/function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(r) {
          var s, a, _yield$B3, _e19, _t14;

          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  r && (r.preventDefault && r.preventDefault(), r.persist && r.persist());
                  s = !0, a = Y(h);
                  F.state.next({
                    isSubmitting: !0
                  });
                  _context10.prev = 3;

                  if (!n.resolver) {
                    _context10.next = 13;
                    break;
                  }

                  _context10.next = 7;
                  return B();

                case 7:
                  _yield$B3 = _context10.sent;
                  _e19 = _yield$B3.errors;
                  _t14 = _yield$B3.values;
                  i.errors = _e19, a = _t14;
                  _context10.next = 15;
                  break;

                case 13:
                  _context10.next = 15;
                  return U(y);

                case 15:
                  if (!j(i.errors)) {
                    _context10.next = 21;
                    break;
                  }

                  F.state.next({
                    errors: {},
                    isSubmitting: !0
                  });
                  _context10.next = 19;
                  return e(a, r);

                case 19:
                  _context10.next = 26;
                  break;

                case 21:
                  _context10.t0 = t;

                  if (!_context10.t0) {
                    _context10.next = 25;
                    break;
                  }

                  _context10.next = 25;
                  return t(_objectSpread({}, i.errors), r);

                case 25:
                  n.shouldFocusError && z(y, function (e) {
                    return d(i.errors, e);
                  }, _.mount);

                case 26:
                  _context10.next = 31;
                  break;

                case 28:
                  _context10.prev = 28;
                  _context10.t1 = _context10["catch"](3);
                  throw s = !1, _context10.t1;

                case 31:
                  _context10.prev = 31;
                  i.isSubmitted = !0, F.state.next({
                    isSubmitted: !0,
                    isSubmitting: !1,
                    isSubmitSuccessful: j(i.errors) && s,
                    submitCount: i.submitCount + 1,
                    errors: i.errors
                  });
                  return _context10.finish(31);

                case 34:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, null, [[3, 28, 31, 34]]);
        }));

        return function (_x17) {
          return _ref17.apply(this, arguments);
        };
      }();
    },
    watch: function watch(e, t) {
      return L(e) ? F.watch.subscribe({
        next: function next(r) {
          return e(R(void 0, t), r);
        }
      }) : R(e, t, !0);
    },
    setValue: P,
    getValues: G,
    reset: function reset(t) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var s = t || g,
          a = Y(s),
          n = t && !j(t) ? a : g;

      if (r.keepDefaultValues || (g = s), !r.keepValues) {
        if (r.keepDirtyValues) {
          var _iterator8 = _createForOfIteratorHelper(_.mount),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _e20 = _step8.value;
              d(i.dirtyFields, _e20) ? H(n, _e20, d(h, _e20)) : P(_e20, d(n, _e20));
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        } else {
          if (X && c(t)) {
            var _iterator9 = _createForOfIteratorHelper(_.mount),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _e21 = _step9.value;

                var _t15 = d(y, _e21);

                if (_t15 && _t15._f) {
                  var _e22 = Array.isArray(_t15._f.refs) ? _t15._f.refs[0] : _t15._f.ref;

                  try {
                    me(_e22) && _e22.closest("form").reset();
                    break;
                  } catch (e) {}
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          }

          y = {};
        }

        h = e.shouldUnregister ? r.keepDefaultValues ? Y(g) : {} : a, F.array.next({
          values: n
        }), F.watch.next({
          values: n
        });
      }

      _ = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        watchAll: !1,
        focus: ""
      }, p.mount = !A.isValid || !!r.keepIsValid, p.watch = !!e.shouldUnregister, F.state.next({
        submitCount: r.keepSubmitCount ? i.submitCount : 0,
        isDirty: r.keepDirty || r.keepDirtyValues ? i.isDirty : !(!r.keepDefaultValues || le(t, g)),
        isSubmitted: !!r.keepIsSubmitted && i.isSubmitted,
        dirtyFields: r.keepDirty || r.keepDirtyValues ? i.dirtyFields : r.keepDefaultValues && t ? _e(g, t) : {},
        touchedFields: r.keepTouched ? i.touchedFields : {},
        errors: r.keepErrors ? i.errors : {},
        isSubmitting: !1,
        isSubmitSuccessful: !1
      });
    },
    resetField: function resetField(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      d(y, e) && (c(t.defaultValue) ? P(e, d(g, e)) : (P(e, t.defaultValue), H(g, e, t.defaultValue)), t.keepTouched || ne(i.touchedFields, e), t.keepDirty || (ne(i.dirtyFields, e), i.isDirty = t.defaultValue ? T(e, d(g, e)) : T()), t.keepError || (ne(i.errors, e), A.isValid && k()), F.state.next(_objectSpread({}, i)));
    },
    clearErrors: function clearErrors(e) {
      e ? O(e).forEach(function (e) {
        return ne(i.errors, e);
      }) : i.errors = {}, F.state.next({
        errors: i.errors
      });
    },
    unregister: Q,
    setError: function setError(e, t, r) {
      var s = (d(y, e, {
        _f: {}
      })._f || {}).ref;
      H(i.errors, e, _objectSpread(_objectSpread({}, t), {}, {
        ref: s
      })), F.state.next({
        name: e,
        errors: i.errors,
        isValid: !1
      }), r && r.shouldFocus && s && s.focus && s.focus();
    },
    setFocus: function setFocus(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var r = d(y, e)._f,
          s = r.refs ? r.refs[0] : r.ref;

      s.focus(), t.shouldSelect && s.select();
    },
    getFieldState: J
  };
}

exports.Controller = function (e) {
  return e.render(W(e));
}, exports.FormProvider = function (e) {
  var r = e.children,
      s = _objectWithoutProperties(e, _excluded4);

  return t.default.createElement(k.Provider, {
    value: s
  }, r);
}, exports.appendErrors = P, exports.get = d, exports.set = H, exports.useController = W, exports.useFieldArray = function (e) {
  var r = D(),
      _e$control2 = e.control,
      s = _e$control2 === void 0 ? r.control : _e$control2,
      a = e.name,
      _e$keyName = e.keyName,
      n = _e$keyName === void 0 ? "id" : _e$keyName,
      i = e.shouldUnregister,
      _t$default$useState5 = t.default.useState(s._getFieldArray(a)),
      _t$default$useState6 = _slicedToArray(_t$default$useState5, 2),
      o = _t$default$useState6[0],
      u = _t$default$useState6[1],
      l = t.default.useRef(s._getFieldArray(a).map(G)),
      c = t.default.useRef(o),
      f = t.default.useRef(a),
      m = t.default.useRef(!1);

  f.current = a, c.current = o, s._names.array.add(a), U({
    callback: t.default.useCallback(function (_ref18) {
      var e = _ref18.values,
          t = _ref18.name;

      if (t === f.current || !t) {
        var _t16 = d(e, f.current, []);

        u(_t16), l.current = _t16.map(G);
      }
    }, []),
    subject: s._subjects.array
  });
  var y = t.default.useCallback(function (e) {
    m.current = !0, s._updateFieldArray(a, e);
  }, [s, a]);
  return t.default.useEffect(function () {
    s._stateFlags.action = !1, K(a, s._names) && s._subjects.state.next({}), m.current && s._executeSchema([a]).then(function (e) {
      var t = d(e.errors, a),
          r = d(s._formState.errors, a);
      (r ? !t && r.type : t && t.type) && (t ? H(s._formState.errors, a, t) : ne(s._formState.errors, a), s._subjects.state.next({
        errors: s._formState.errors
      }));
    }), s._subjects.watch.next({
      name: a,
      values: s._formValues
    }), s._names.focus && z(s._fields, function (e) {
      return e.startsWith(s._names.focus);
    }), s._names.focus = "", s._proxyFormState.isValid && s._updateValid();
  }, [o, a, s]), t.default.useEffect(function () {
    return !d(s._formValues, a) && s._updateFieldArray(a), function () {
      (s._options.shouldUnregister || i) && s.unregister(a);
    };
  }, [a, s, n, i]), {
    swap: t.default.useCallback(function (e, t) {
      var r = s._getFieldArray(a);

      ae(r, e, t), ae(l.current, e, t), y(r), u(r), s._updateFieldArray(a, r, ae, {
        argA: e,
        argB: t
      }, !1);
    }, [y, a, s]),
    move: t.default.useCallback(function (e, t) {
      var r = s._getFieldArray(a);

      te(r, e, t), te(l.current, e, t), y(r), u(r), s._updateFieldArray(a, r, te, {
        argA: e,
        argB: t
      }, !1);
    }, [y, a, s]),
    prepend: t.default.useCallback(function (e, t) {
      var r = O(Y(e)),
          n = re(s._getFieldArray(a), r);
      s._names.focus = J(a, 0, t), l.current = re(l.current, r.map(G)), y(n), u(n), s._updateFieldArray(a, n, re, {
        argA: Z(e)
      });
    }, [y, a, s]),
    append: t.default.useCallback(function (e, t) {
      var r = O(Y(e)),
          n = Q(s._getFieldArray(a), r);
      s._names.focus = J(a, n.length - 1, t), l.current = Q(l.current, r.map(G)), y(n), u(n), s._updateFieldArray(a, n, Q, {
        argA: Z(e)
      });
    }, [y, a, s]),
    remove: t.default.useCallback(function (e) {
      var t = se(s._getFieldArray(a), e);
      l.current = se(l.current, e), y(t), u(t), s._updateFieldArray(a, t, se, {
        argA: e
      });
    }, [y, a, s]),
    insert: t.default.useCallback(function (e, t, r) {
      var n = O(Y(t)),
          i = ee(s._getFieldArray(a), e, n);
      s._names.focus = J(a, e, r), l.current = ee(l.current, e, n.map(G)), y(i), u(i), s._updateFieldArray(a, i, ee, {
        argA: e,
        argB: Z(t)
      });
    }, [y, a, s]),
    update: t.default.useCallback(function (e, t) {
      var r = Y(t),
          n = ie(s._getFieldArray(a), e, r);
      l.current = _toConsumableArray(n).map(function (t, r) {
        return t && r !== e ? l.current[r] : G();
      }), y(n), u(_toConsumableArray(n)), s._updateFieldArray(a, n, ie, {
        argA: e,
        argB: r
      }, !0, !1);
    }, [y, a, s]),
    replace: t.default.useCallback(function (e) {
      var t = O(Y(e));
      l.current = t.map(G), y(_toConsumableArray(t)), u(_toConsumableArray(t)), s._updateFieldArray(a, _toConsumableArray(t), function (e) {
        return e;
      }, {}, !0, !1);
    }, [y, a, s]),
    fields: t.default.useMemo(function () {
      return o.map(function (e, t) {
        return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, n, l.current[t] || G()));
      });
    }, [o, n])
  };
}, exports.useForm = function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var r = t.default.useRef(),
      _t$default$useState7 = t.default.useState({
    isDirty: !1,
    isValidating: !1,
    dirtyFields: {},
    isSubmitted: !1,
    submitCount: 0,
    touchedFields: {},
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    errors: {}
  }),
      _t$default$useState8 = _slicedToArray(_t$default$useState7, 2),
      s = _t$default$useState8[0],
      a = _t$default$useState8[1];

  r.current ? r.current.control._options = e : r.current = _objectSpread(_objectSpread({}, Ue(e)), {}, {
    formState: s
  });
  var n = r.current.control,
      i = t.default.useCallback(function (e) {
    E(e, n._proxyFormState, !0) && (n._formState = _objectSpread(_objectSpread({}, n._formState), e), a(_objectSpread({}, n._formState)));
  }, [n]);
  return U({
    subject: n._subjects.state,
    callback: i
  }), t.default.useEffect(function () {
    n._stateFlags.mount || (n._proxyFormState.isValid && n._updateValid(), n._stateFlags.mount = !0), n._stateFlags.watch && (n._stateFlags.watch = !1, n._subjects.state.next({})), n._removeUnmounted();
  }), r.current.formState = C(s, n._proxyFormState), r.current;
}, exports.useFormContext = D, exports.useFormState = T, exports.useWatch = q;